module.exports = __webpack_public_path__ + "img/CAMPOBASSO.5c7dc364.png";